<template>
  <div class="k-halo-layer" :style="{ '--k-halo-intensity': intensity }">
    <span
      v-for="blob in activeBlobs"
      :key="blob.tone"
      class="k-halo"
      :class="`k-halo--${blob.tone}`"
      :style="{ left: blob.left, top: blob.top, width: `${blob.size}px`, height: `${blob.size}px` }"
    />
  </div>
</template>

<script>
export default {
  name: "KHaloBackground",
  props: {
    intensity: {
      type: Number,
      default: 1,
    },
    blobs: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      defaultBlobs: [
        { tone: "blue", left: "-5%", top: "-15%", size: 320 },
        { tone: "lavender", left: "38%", top: "-25%", size: 340 },
        { tone: "rose", left: "72%", top: "5%", size: 300 },
        { tone: "peach", left: "55%", top: "60%", size: 260 },
        { tone: "mint", left: "0%", top: "65%", size: 240 },
      ],
    };
  },
  computed: {
    activeBlobs() {
      return this.blobs || this.defaultBlobs;
    },
  },
};
</script>
